import { render } from "./smsLoader.vue?vue&type=template&id=b4a215c2&scoped=true"
import script from "./smsLoader.vue?vue&type=script&lang=js"
export * from "./smsLoader.vue?vue&type=script&lang=js"

import "./smsLoader.vue?vue&type=style&index=0&id=b4a215c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a215c2"]])

export default __exports__